// extracted by mini-css-extract-plugin
module.exports = {"vacancyManagerTemplates":"vacancyManagerTemplates_vacancyManagerTemplates__zmUWj"};